import { Component } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { LoginResponseModel } from 'src/app/modules/login/models/loginResponseModel';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {
  tokenData: LoginResponseModel = new LoginResponseModel();
  constructor(private authService: AuthService, private router: Router) {
    const tokenDatajson = localStorage.getItem('token_data');
    if(tokenDatajson){
      this.tokenData = JSON.parse(tokenDatajson);
    }
  }

  environment = environment;
  
  addBodyClass(event: Event) {
    event.preventDefault(); // Optional: Prevent anchor default behavior
    document.body.classList.toggle('sidebar-close');
  }

  logout(){
        this.authService.logout();
        this.router.navigate(['/login']);
  }
}
